import { useEffect, useState } from "react"

export const useHeaderAndBodyScrollSync = (
  headerContainerRef: React.MutableRefObject<HTMLDivElement>,
  tableContainerRef: React.MutableRefObject<HTMLDivElement>
) => {
  const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false)

  // Sync horizontal scroll between header and body
  useEffect(() => {
    let isScrolling = false

    const headerElement = headerContainerRef.current
    const tableElement = tableContainerRef.current

    if (!headerElement || !tableElement) {
      return
    }

    const handleScroll =
      (scrollElement: any, repeatScrollElement: any) => () => {
        if (!!scrollElement && !!repeatScrollElement && !isScrolling) {
          isScrolling = true

          repeatScrollElement.scrollLeft = scrollElement.scrollLeft

          setTimeout(() => {
            isScrolling = false
          }, 10)
        }
      }

    const handleHeaderScroll = handleScroll(headerElement, tableElement)
    const handleTableScroll = handleScroll(tableElement, headerElement)

    headerElement?.addEventListener("scroll", handleHeaderScroll)
    tableElement?.addEventListener("scroll", handleTableScroll)

    return () => {
      headerElement?.removeEventListener("scroll", handleHeaderScroll)
      tableElement?.removeEventListener("scroll", handleTableScroll)
    }
  }, [])

  // Check for horizontal scroll
  useEffect(() => {
    const tableElement = tableContainerRef.current

    if (!tableElement) return

    const checkScroll = () => {
      const hasScroll = tableElement.scrollWidth > tableElement.clientWidth
      setHasHorizontalScroll(hasScroll)
    }

    checkScroll()

    const resizeObserver = new ResizeObserver(() => {
      checkScroll()
    })
    resizeObserver.observe(tableElement)

    const mutationObserver = new MutationObserver(() => {
      checkScroll()
    })
    mutationObserver.observe(tableElement, {
      childList: true,
      subtree: true
    })

    return () => {
      resizeObserver.disconnect()
      mutationObserver.disconnect()
    }
  }, [])

  return {
    hasHorizontalScroll
  }
}
